export function selectResetPassword(state: any): any {
    return state.resetPassword;
}
